import React from 'react';

export default class JavascriptProg extends React.Component {

    constructor(props) {
        super(props);

        this.state = {jsResult: ""};

        this.run = this.run.bind(this);
        this.writeHtml = this.writeHtml.bind(this);
        this.readInt = this.readInt.bind(this);
        this.readString0 = this.readString0.bind(this);
        this.printInt = this.printString.bind(this);
        this.printString = this.printString.bind(this);
    }

    printInt(arg) {
        this.writeHtml(arg);
    }

    printString(arg) {
        this.writeHtml(arg);
    }

    readInt() {
        var res = parseInt(prompt("Enter number(s):"),10);
        if (isNaN(res)) {
            throw new Error("Could not parse int");
        } else {
            return res
        }
    }

    readString0() {
        var s = prompt("Enter string(s):");
        return s;
    }

    writeHtml(line) {
        if(this.props.writeM) {
            this.setState({jsResult: this.state.jsResult + line + "\n"});
        }
    }

    run(){
        //Clean the slate first before running new program
        this.setState({jsResult:""});

        var t0, t1;

        this.printString(this.props.fileName + " is running:\n");

        t0 = performance.now();

        window[this.props.fileName](this);

        t1 = performance.now();

        //Get time difference
        var diff = (t1 - t0);

        if(this.props.perfM) {
            this.printString("\nProgram took " + diff +
                " ms.");
        }
        this.props.over(diff)
    }

    render() {
        const {jsResult} = this.state;

        return (
            <p className="Block-result">
            {this.props.perfM && this.props.writeM ? jsResult : ">Writing is disabled"}
            </p>
        )
    }
}


// WEBPACK FOOTER //
// ./src/JavascriptProg.js